// import React from 'react';

// function About({ aboutContent, LanguageSelected, t ,divstyle }) {
//   return (
//     <div>
//       {aboutContent != '' && aboutContent.length > 0 && (
//         <div className={`pt-5 pb-5 pl-3 pr-3  ${divstyle} w-full`}>
//           <div className="pb-0 pb-3">
//             <h1
//               className={`${
//                 LanguageSelected === 'ar'
//                   ? 'title title--h1 first-title title__separate text-theme right-2'
//                   : 'title left-2 title--h1 first-title title__separate text-theme'
//               }`}
//             >
//               {t("À propos")}
//             </h1>
//             <p className='textaboutprofile leading-normal ml-2 text-theme'>{aboutContent[0]?.Description.fr}</p>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

import React from 'react';

function About({ aboutContent, LanguageSelected, t, divstyle }) {
  if (!aboutContent || aboutContent.length === 0) return null;
  
  const about = aboutContent[0];
  const description = about?.description || {};
  const displayText = description[LanguageSelected] || '';

  // Hide section if selected language has no content
  if (!displayText || displayText.trim() === '') {
    return null;
  }

  return (
    <div>
      <div className={`pt-5 pb-5 pl-3 pr-3 ${divstyle || 'sections'} w-full`}>
        <div className="pb-0 pb-3">
          <h1
            className={`${
              LanguageSelected === 'ar'
                ? 'title title--h1 first-title title__separate text-theme right-2'
                : 'title left-2 title--h1 first-title title__separate text-theme'
            }`}
          >
            {t("À propos")}
          </h1>
          <p 
            className={`textaboutprofile leading-normal ${
              LanguageSelected === 'ar' ? 'mr-2 text-right' : 'ml-2 text-left'
            } text-theme`}
            dir={LanguageSelected === 'ar' ? 'rtl' : 'ltr'}
          >
            {displayText}
          </p>
        </div>
      </div>
    </div>
  );
}

export default About;
